/**
 * Created by tendlich on 03/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        BaseModel = require("models/BaseModel"),
        ApiResources = require("assets/data/apiResources.json"),
        MessagingAgentModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        MessagingAgentModel = BaseModel.extend({
            name: "MessagingAgentModel",
            idAttribute: 'pId',
            resource: ApiResources.AcCdnAPI.Agent,
            defaults: {
                nickname: ""
            }
        });
    });

    return MessagingAgentModel;
});
